import dayjs from '~~/src/helpers/dayJs';
import type { OfferPage } from '~~/src/server/transformers/page/offerPage';

export default function getOfferPageSchema(
  page: OfferPage,
  options?: { url?: string },
): any {
  const validUntil = page.offer.validUntil
    ? dayjs(page.offer.validUntil).format()
    : null;
  return [
    defineProduct({
      name: page.title,
      description: page.offer.description,
      brand: { name: page.offer.manufacturer },
      potentialAction: 'BuyAction',
      keywords: page.offer.tags?.map((x) => x.title)?.join(','),
      audience: [
        'dentists',
        'dentalAssistants',
        'assistantDentists',
        'dentalAdministrativeAssistants',
      ],
      image: page.offer.image?.mobile.url,
      offers: {
        price: page.offer.price ?? 0,
        priceCurrency: 'EUR',
        validFrom: dayjs(page.postDate).format(),
        availabilityEnds: validUntil,
        availability: 'InStock',
        url: options.url,
      },
    }),
  ];
}
